import { render, staticRenderFns } from "./user-edit-details.vue?vue&type=template&id=28adf2ae&scoped=true"
import script from "./user-edit-details.vue?vue&type=script&lang=js"
export * from "./user-edit-details.vue?vue&type=script&lang=js"
import style0 from "./user-edit-details.vue?vue&type=style&index=0&id=28adf2ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28adf2ae",
  null
  
)

export default component.exports